import styled from "@mui/system/styled";
import { FaXmark } from "react-icons/fa6";

import { colors } from "../../../styles/colors";
import fontWeight from "../../../styles/mui/fontWeight";

export const HeaderTitle = {
  backgroundColor: colors.primary.main,
  padding: "24px",
};

export const TextHeader = {
  textAlign: "center",
  fontSize: "x-large",
};

export const SubmitStyle = {
  display: "flex",
  justifyContent: "end",
  margin: "20px 0 0 0",
  paddingRight: "20px",
  maxWidth: "100%",
};
export const EligibilityFormStyle = {
  display: "flex",
  justifyContent: "center",
  margin: "20px",
  maxWidth: "100%",
};

export const SubmitStyleGridSpace1 = {
  display: "flex",
  justifyContent: "start",
};

export const InputHeader = {
  display: "flex",
  flexDirection: "column",
};

export const TextSubHeader = {
  display: "flex",
  textAlign: "center",
  justifyContent: "center",
  margin: "0.62rem",
  maxWidth: "100%",
};

export const CreateAuthContainer = {
  backgroundColor: colors.white[1],
  display: "flex",
  flexDirection: "column",
  padding: "20px 40px 20px 40px",
  maxWidth: "100%",
  minWidth: "90%",
  minHeight: "75vh",
  maxHeight: "75vh",
  overflowY: "auto",
  overflowX: "hidden",
};

export const CreateAuthContainerFooter = {
  backgroundColor: colors.portalColor[17],
  display: "flex",
  justifyContent: "center",
  padding: "20px 0 20px 0",
  maxWidth: "100%",
};

/**Form component */
export const PhoneNumberInputStyle = {
  borderRadius: "0.0625rem",
  borderColor: colors.black[13],
  width: "100%",
  "& .MuiInputBase-root.MuiInput-root": {
    marginTop: 0,
    height: "2.4rem",
  },
  "& .MuiInputBase-input.MuiInput-input": {
    WebkitBoxShadow: "none",
    padding: "0.2rem 0 .35rem 0.7rem",
    border: `0.0625rem solid ${colors.black[13]}`,
    borderRadius: "4px",
    height: "1.6rem",
    fontSize: "0.8rem",
    "&.Mui-focused fieldset": {
      borderColor: colors.portalColor[16],
      border: `3px solid ${colors.portalColor[16]}`,
    },
  },
};

export const TextFieldStyle = (width: boolean, multiline?: boolean) => ({
  borderRadius: "0.0625rem",
  borderColor: colors.black[13],
  width: width ? "12rem" : "100%",
  height: multiline ? "7.2rem" : "2.4rem",
  //marginRight: "1.25rem",
  "& .MuiOutlinedInput-root": {
    height: multiline ? "7.2rem" : "2.4rem",
    "& input": {
      marginLeft: "0.7rem",
      height: multiline ? "7.2rem" : "2.4rem",
      borderRadius: "0.0625rem",
      padding: "0",
      fontSize: "0.8rem",
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.portalColor[16],
      border: `3px solid ${colors.portalColor[16]}`,
    },
    "&.Mui-disabled": {
      backgroundColor: colors.grey[4],
    },
    "&.Mui-error fieldset": {
      borderColor: colors.grey[4],
    },
  },
});

export const AutocompleteFieldStyle = (width: boolean) => ({
  borderRadius: "0.0625rem",
  borderColor: colors.black[13],
  width: width ? "18rem" : "100%",
  "& .MuiOutlinedInput-root": {
    padding: "0",
    "& input": {
      marginLeft: "0.7rem",
      height: 0,
      borderRadius: "0.0625rem",
      padding: "0",
      width: "100%",
      fontSize: "1.25rem",
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.portalColor[16],
      border: `3px solid ${colors.portalColor[16]}`,
    },
    "&.Mui-disabled": {
      backgroundColor: colors.grey[4],
    },
    "& .MuiInputLabel-root": {
      display: "none",
    },
  },
  "& .MuiInputBase-input": {
    height: "1.5rem",
  },
});

export const SearchButton = {
  backgroundColor: colors.portalColor[13],
};

export const StyleGridColumn = {
  display: "flex",
  flexDirection: "column",
};
export const StyleGridColumn2 = {
  display: "flex",
  justifyContent: "start",
  flexDirection: "column",
};

export const TextHeaderLarge = {
  textAlign: "center",
  fontSize: "large",
};
export const TextHeadermedium = (isMargin: boolean) => ({
  fontSize: "medium",
  color: colors.black[13],
  marginTop: "0.6rem",
  marginLeft: isMargin ? "2rem" : "0",
  marginBottom: "1rem",
  marginRight: "0",
});

export const ServiceAddressOptions = {
  textAlign: "center",
  fontSize: "large",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  fontWeight: fontWeight[5],
};

export const TextHeaderStartLarge = {
  textAlign: "left",
  fontSize: "large",
};

export const RefSourceRadio = (flag?: boolean) => ({
  display: "flex",
  flexDirection: "row",
  pointerEvents: flag ? "none" : "initial",
});

export const CheckboxDirection = () => ({
  display: "flex",
  flexDirection: "column",
  width: "fit-content"
});

export const StyleGridRow = {
  display: "flex",
  justifyContent: "start",
  flexDirection: "row",
  paddingLeft: "1rem"
};

export const UnderlineText = {
  fontStyle: "italic",
  color: colors.portalColor[13],
  textDecoration: "underline",
};

export const DangerText = {
  marginTop: 0.2,
  color: colors.red[100],
  fontSize: "small",
  fontStyle: "italic",
};

export const ItalicText = {
  marginTop: 0.5,
  fontSize: "small",
  fontStyle: "italic",
};

export const FlexColumn = { display: "flex", flexDirection: "column" };
export const FlexRow = { display: "flex", flexDirection: "row" };

export const Document1 = {
  padding: "0.3rem 0.625rem",
  borderRadius: "1.25rem",
  fontSize: "0.81rem",
  backgroundColor: colors.grey[4],
};

export const Document2 = {
  display: "flex",
};

export const Document3 = { display: "flex", flexDirection: "column", gap: 1 };

export const MarginBottom = {
  marginBottom: "1.25rem",
  backgroundColor: colors.grey[2],
};

export const DocumentBox = { width: "100%", padding: "1.25rem" };

export const ChipStyle = {
  marginTop: 2,
  width: "fit-content",
  backgroundColor: colors.grey[1],
  borderRadius: 0.5,
  color: colors.black[1],
};

export const ChipContainer = { width: "fit-content" };

export const ChipIconStyle = {
  color: colors.black[1],
  fontSize: "0.85rem",
  cursor: "pointer",
}

export const DangerTextReferralCreated = {
  marginTop: 0.5,
  color: colors.red[100],
  fontSize: "large",
};

export const TextHeaderStartMedium = {
  textAlign: "left",
  fontSize: "medium",
};

export const SubmitStyleCenter = {
  display: "flex",
  justifyContent: "center",
  margin: "20px 0 0 0",
  paddingRight: "20px",
  maxWidth: "100%",
};

export const EligibilityMessageStyle = {
  maxWidth: "100%",
  margin: "1rem",
};

export const FaXmarkIcon = styled(FaXmark as React.ComponentType)(() => ({
  color: colors.black[1],
  fontSize: "0.85rem",
  cursor: "pointer",
}));

export const AmeriHealthList = {
  paddingLeft: "3rem",
  listStyleType: "disc",
}

export const AmeriItalicText = {
  fontSize: "0.95rem",
  fontStyle: "italic",
  fontWeight: "bold",
}

export const MemberNotFoundList = {
  listStyleType: "disc",
  padding: "0rem",
}

export const ListItemStyle = {
  display: "list-item",
  padding: "0",
}

export const uploadHyperLink = {
  textDecoration: "none",
  fontSize: "0.95rem",
  display: "inline",
  color: colors.portalColor[31],
}

export const memberContinue = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
}

export const fileModalStyle = {
  color: colors.fonts[6],
  cursor: "pointer",
  display: "flex",
  gap: 1,
  paddingTop: "0.3rem",
  paddingBottom: "0.3rem",
};

export const fileModalIconStyle = {
  fontSize: 14,
  mr: 1,
  padding: "0rem 0.5rem",
  lineHeight: 1,
  display: "inline-block",
  alignItems: "start",
};